import { ModuleConditionTypeEnum, ZoneTypeEnum } from "@/includes/logic/Modules/types";
import ConfigCondition from "../../ConfigCondition";

export default class ZoneCondition extends ConfigCondition {
  type = ModuleConditionTypeEnum.Zone;

  value: ZoneTypeEnum = ZoneTypeEnum.All
}
